export default {
    emitEventGoogleAnalytics($ga, eventCategory, eventAction) {
        if ($ga) {
            $ga.event({
                eventCategory,
                eventAction,
            })
        }
    },

    emitLogInGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-in', 'log-in')
    },

    emitRegistrationGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'new-registration')
    },

    emitRegistrationByInviteGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'new-registration-by-invite')
    },

    emitRegistrationByAdminGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'new-registration-by-admin')
    },

    emitRegistrationCompletedGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'registration-completed')
    },

    loadGoogleAnalytics(trackingId) {
        if (process.env.VUE_APP_ENV !== 'production') {
            return
        }

        if (document.getElementById('google-analytics')) {
            return
        }

        const script = document.createElement('script')
        script.id = 'google-analytics'
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
        document.head.appendChild(script)

        script.onload = () => {
            window.dataLayer = window.dataLayer || []
            function gtag() {
                window.dataLayer.push(arguments)
            }
            window.gtag = gtag
            gtag('js', new Date())
            gtag('config', trackingId)
        }
    },
}
